import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="maps"
export default class extends Controller {

  static targets = ['map'];

  connect() {
    this.first = false;
  }

  mapTargetConnected() {
    if (this.first) return;

    this.setup()

    this.first = true
  }

  token() {
    if (window.location.href.indexOf('movesgreen.nl') > -1)
      return 'eyJraWQiOiI3TDY2UFhXUllYIiwidHlwIjoiSldUIiwiYWxnIjoiRVMyNTYifQ.eyJpc3MiOiJEVEU5UTY3Mzk3IiwiaWF0IjoxNzMyNzk5Njk0LCJvcmlnaW4iOiIqLm1vdmVzZ3JlZW4ubmwifQ.49HhGPIelhT0CzrheU9beIsWFRTsTFdmxufjZEA7HxR6lSqS5Gm_6cJPO1hzTvah7hpf9FE1eG8s7fGL9OctKQ'

    return "eyJraWQiOiJCQlFLTVMyOFg2IiwidHlwIjoiSldUIiwiYWxnIjoiRVMyNTYifQ.eyJpc3MiOiJEVEU5UTY3Mzk3IiwiaWF0IjoxNzMyNzk5Njk0LCJvcmlnaW4iOiIqLndlYmljcy5kZXYifQ.TGYnnypxKHVCbJqlAAjwxAiH6_UT6InRl1YmhJzFMw3vAgvdxg6tOSdSQtw5mu87m0AODty1ZbqPSUQYeRakEg"
  }

  setup() {
    let script = document.createElement('script')
    script.src = "https://cdn.apple-mapkit.com/mk/5.x.x/mapkit.core.js"
    script.crossorigin = true
    script.async = true
    script.dataset.callback = 'initMapKit'
    script.dataset.token = this.token()
    script.dataset.libraries = "map,annotations"

    document.body.append(script)

    this.main()
  }

  setupMapKitJs = async () => {
    // If MapKit JS is not yet loaded...
    if (!window.mapkit || window.mapkit.loadedLibraries.length === 0) {
      // ...await <script>'s data-callback (window.initMapKit).
      await new Promise(resolve => { window.initMapKit = resolve });
      // Clean up.
      delete window.initMapKit;
    }
  };

  main = async () => {
    await this.setupMapKitJs();

    this.mapTargets.forEach(element => {
      let controller = this.application.getControllerForElementAndIdentifier(element, 'map')

      setTimeout(() => {
        controller.setup()
      }, 1000);
    })
  }
}
